import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const RackSingleEditPageRBAC = {
  pageID: '8c2d64d3bbbc777cdfdff72c62706e6b',
  elementID: {},
} as const

export const useRBACRackSingleEditPage = createUseRBAC(RackSingleEditPageRBAC.elementID)

export type UseRBACRackSingleEditPageType = ReturnType<typeof useRBACRackSingleEditPage>
